import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import {environment} from '../../../environments/environment';


export class MonetaryValue {
  public Amount: number;
  public At: Date;

  constructor() {
    this.Amount = 0;
    this.At = new Date();
  }
}

export class CreateAssetRequest {
  public Name: string;
  public Description : string;
  public Deposit: MonetaryValue;
  public PurchasePrice: MonetaryValue;
  public IsExploratory: boolean;
  public Valuations: MonetaryValue[];

  constructor() {
    this.Name = "";
    this.Description = "";
    this.IsExploratory = true;
    this.Deposit = new MonetaryValue();
    this.PurchasePrice = new MonetaryValue();
    this.Valuations = new Array<MonetaryValue>();
  }
}

export class Asset extends CreateAssetRequest {
  public Id: string;
  public OwnerId: string;

  constructor() {
    super();
    this.Id = "";
    this.OwnerId = "";
  }
}

@Injectable({
  providedIn: 'root'
})
export class AssetsService {
  private baseApi: string = environment.apiUrl + "/assets/";

  constructor(private http: HttpClient) { }

  public getAssets(): Observable<Asset[]> {
    return this.http.get<Asset[]>(this.baseApi)
      .pipe(catchError(this.handleError));
  }

  public getAssetById(id: string): Observable<Asset> {
    return this.http.get<Asset>(this.baseApi + id)
      .pipe(catchError(this.handleError));
  }

  public createAsset(asset: CreateAssetRequest): Observable<Asset> {
    return this.http.post<Asset>(this.baseApi, asset)
      .pipe(catchError(this.handleError));
  }

  public updateAsset(asset: Asset): Observable<Asset> {
    return this.http.put<Asset>(this.baseApi + asset.Id, asset)
      .pipe(catchError(this.handleError));
  }

  public deleteAsset(asset: Asset): Observable<unknown> {
    return this.http.delete(this.baseApi + asset.Id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
